import { subscribeConnectionDisplay, setNetworkOnline } from '../state/connection-status-store.js';
import { kickPoll } from '../sync/poller.js';

/** @type {Record<string, { label: string; icon: string }>} */
const MODES = {
  offline: {
    label: 'Connessione assente',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 20h.01"/>
        <path d="M8.5 16.429a5 5 0 0 1 7 0"/>
        <path d="M5 12.859a10 10 0 0 1 5.17-2.69"/>
        <path d="M2 8.82a15 15 0 0 1 4.177-2.643"/>
        <path d="m2 2 20 20"/>
      </svg>`,
  },
  api_unreachable: {
    label: 'Server non raggiungibile',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 12v4"/>
        <path d="M4.93 4.93 19.07 19.07"/>
        <path d="M8 16s1.5-2 4-2 4 2 4 2"/>
        <path d="M9 9h.01"/>
        <path d="M15 9h.01"/>
        <path d="M17.5 11.5a7 7 0 0 0-11-4.5"/>
        <path d="M2 8.82a15 15 0 0 1 4.177-2.643"/>
      </svg>`,
  },
  syncing: {
    label: 'Sincronizzazione in corso',
    icon: `
      <svg class="connection-status__spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
        <path d="M3 3v5h5"/>
        <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
        <path d="M16 16h5v5"/>
      </svg>`,
  },
  outside_schedule: {
    label: 'Fuori orario programmazione',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2"/>
        <path d="M16 2v4"/>
        <path d="M8 2v4"/>
        <path d="M3 10h18"/>
        <path d="M12 14v-2"/>
      </svg>`,
  },
  empty_playlist: {
    label: 'Playlist vuota',
    icon: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M8 6h13"/>
        <path d="M8 12h13"/>
        <path d="M8 18h13"/>
        <path d="M3 6h.01"/>
        <path d="M3 12h.01"/>
        <path d="M3 18h.01"/>
        <path d="m2 2 20 20"/>
      </svg>`,
  },
};

let badgeEl = null;

function ensureBadge() {
  if (badgeEl?.isConnected) return badgeEl;
  badgeEl = null;
  badgeEl = document.createElement('div');
  badgeEl.id = 'connection-status';
  badgeEl.className = 'connection-status';
  badgeEl.setAttribute('role', 'status');
  badgeEl.setAttribute('aria-live', 'polite');
  badgeEl.hidden = true;
  document.body.appendChild(badgeEl);
  return badgeEl;
}

/** @param {import('../state/connection-status-store.js').ConnectionDisplay} display */
function render(display) {
  const el = ensureBadge();
  if (display === 'hidden') {
    el.hidden = true;
    el.classList.remove('is-visible');
    el.removeAttribute('data-mode');
    return;
  }
  const mode = MODES[display];
  el.hidden = false;
  el.classList.add('is-visible');
  el.dataset.mode = display;
  el.setAttribute('aria-label', mode.label);
  el.innerHTML = mode.icon;
}

/** Bottom-right connection badge: offline, API down, or syncing. */
export function startConnectionStatus() {
  ensureBadge();
  setNetworkOnline(navigator.onLine);
  subscribeConnectionDisplay(render);
  window.addEventListener('online', () => {
    setNetworkOnline(true);
    kickPoll();
  });
  window.addEventListener('offline', () => setNetworkOnline(false));
}

/** @deprecated Use startConnectionStatus */
export const startOfflineIndicator = startConnectionStatus;
